// import { Image } from './images.types';
import { IImage } from '@topshots/core-models';
import { Button } from 'shared-components';
import { ButtonIntent } from 'shared-components';
import { useState } from 'react';

export const ImagesTable = ({
  images,
  onDelete,
  onSelectedChanged,
}: {
  images: IImage[];
  onDelete?: (image: IImage) => void;
  onSelectedChanged?: (selected: IImage[]) => void;
}) => {
  const [selected, setSelected] = useState<IImage[]>([]);
  const updateSelected = (s: IImage[]) => {
    setSelected(s);
    onSelectedChanged?.(s);
  };
  return (
    <table>
      <thead>
        <tr>
          <th>
            <input
              checked={selected.length === images.length && images.length > 0}
              onChange={(e) => {
                if (e.currentTarget.checked) {
                  updateSelected(images);
                } else {
                  updateSelected([]);
                }
              }}
              type="checkbox"
            />
          </th>
          <th>Image</th>
          <th colSpan={2}>Name</th>
        </tr>
      </thead>
      <tbody>
        {images.map((image) => (
          <ImageRow
            key={image._id.toString()}
            selected={selected.indexOf(image) > -1}
            image={image}
            onDelete={onDelete}
            onCheckedChange={(checked: boolean) => {
              if (checked) {
                updateSelected([...selected.filter((i) => i !== image), image]);
              } else {
                updateSelected([...selected.filter((i) => i !== image)]);
              }
            }}
          />
        ))}
      </tbody>
    </table>
  );
};

export const ImageRow = ({
  image,
  onDelete,
  selected,
  onCheckedChange,
}: {
  image: IImage;
  onDelete?: (image: IImage) => void;
  selected: boolean;
  onCheckedChange?: (checked: boolean) => void;
}) => {
  return (
    <tr key={image._id.toString()}>
      <td>
        <input
          onChange={(ev) => {
            onCheckedChange?.(ev.currentTarget.checked);
          }}
          checked={selected}
          type="checkbox"
        />
      </td>
      <td>
        <img
          style={{
            maxWidth: '100px',
          }}
          src={image.isArchived ? image.archiveUrl : image.url}
          alt={image.name}
        />
      </td>
      <td>{image.name}</td>
      <td>
        <Button
          onClick={() => {
            onDelete?.(image);
          }}
          intent={ButtonIntent.Negative}
        >
          Delete
        </Button>
      </td>
    </tr>
  );
};
